import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import { Link, useParams } from "react-router-dom";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import api from "../../../api";


const EditExam = () => {
  const questionPaperLayoutPlugin = defaultLayoutPlugin();
  const solutionLayoutPlugin = defaultLayoutPlugin();
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [name, setName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timeLimit, setTimeLimit] = useState("");
  const [attempts, setAttempts] = useState("");
  const [className,setClassName]=useState('')
  const [course,setCourse]=useState(null)
  const [courses,setCourses]=useState([])
  const [physicsTopics, setPhysicsTopics] = useState("");
  const [chemistryTopics, setChemistryTopics] = useState("");
  const [biologyTopics, setBiologyTopics] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const params=useParams()
  const [questionPaperFile, setQuestionPaperFile] = useState(null);
  const [solutionFile, setSolutionFile] = useState(null);
  const [previewQuestionPaper, setPreviewQuestionPaper] = useState(null);
  const [previewSolution, setPreviewSolution] = useState(null);
  const [questionPaperUrl,setQuestionPaperUrl]=useState(null)
  const [solutionUrl,setSolutionUrl]=useState(null)
  const [loading,setLoading] =useState(false)

  const [message, setMessage] = useState("");
  const formatTopics = (value) =>
    value
      .split(",")
      .map((topic) => topic.trim())
      .filter(Boolean);

  useEffect(() => {
      const timer = setTimeout(() => {
        setMessage(false);
      }, 4000);
      return () => clearTimeout(timer);
    }, [message]);
  const getCourses = () => {
    axios.get(`${baseUrl}/course/by-class?className=${className}`)
      .then(res => setCourses(res.data))
      .catch(err => console.log(err))
  }

  const handleCourse = (e) => {
    const selectedCourseId = e.target.value;
    const selectedCourse = courses.find(c => c._id === selectedCourseId); // Find the selected course by _id
    setCourse(selectedCourse);  // Update the course state with the full course object
  };

  useEffect(() => {
    getCourses()
  }, [className])
  useEffect(()=>{
    axios.get(`${baseUrl}/course/all`)
    .then(res=>setCourses(res.data))
    .catch(err=>console.log(err))
    .catch(err=>console.log(err))
    axios.get(`${baseUrl}/exam/get/?id=${params.id}`)
    .then(res=>{
        setName(res.data.examName)
        setStartDate(res.data.startDate)
        setEndDate(res.data.endDate)
        setTimeLimit(res.data.timeLimit)
        setAttempts(res.data.attempts)
        setClassName(res.data.className)
        setCourse(res.data.course)
        setPhysicsTopics(res.data.topics?.Physics?.join(", ") || "")
        setChemistryTopics(res.data.topics?.Chemistry?.join(", ") || "")
        setBiologyTopics(res.data.topics?.Biology?.join(", ") || "")
        setQuestionPaperUrl(res.data.questionPaper || null)
        setSolutionUrl(res.data.solution || null)

    })
    .catch(err=>console.log(err))
    .catch((err) => setMessage(err.response.data));
  },[]
)

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("startDate", startDate);
    formData.append("endDate", endDate);
    formData.append("timeLimit", timeLimit);
    formData.append("attempts", attempts);
    formData.append("className", className);
    formData.append("course", JSON.stringify(course));
    formData.append("topics", JSON.stringify({
      Physics: formatTopics(physicsTopics),
      Chemistry: formatTopics(chemistryTopics),
      Biology: formatTopics(biologyTopics),
    }));
    if (questionPaperFile) formData.append("questionPaper", questionPaperFile);
    if (solutionFile) formData.append("solution", solutionFile);
  
    try {
      setLoading(true)
      const res = await api.post(
        `${baseUrl}/exam/update/?id=${params.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      setMessage(res.data);
    } catch (err) {
      setMessage(err.response?.data?.message || "Update failed");
    } finally {
      setLoading(false)
    }
  };

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside
        className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
      >
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
        <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/exams' className="text-decoration-none">All Exams</Link>
              </li>
              <li className="breadcrumb-item active">
                Create
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Edit Exam</h4>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="examName" className="form-label">
                  Exam Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="examName"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="startDate" className="form-label">
                  Start Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  placeholder=""
                  onChange={(e) => setStartDate(e.target.value)}
                  value={startDate}
                  min={today}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="endDate" className="form-label">
                  End Date
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  placeholder=""
                  onChange={(e) => setEndDate(e.target.value)}
                  value={endDate}
                  min={today}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <label htmlFor="timeLimit" className="form-label">
                  Time Limit in minutes
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="timeLimit"
                  placeholder=""
                  onChange={(e) => setTimeLimit(e.target.value)}
                  value={timeLimit}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="attempts" className="form-label">
                  Number of attempts
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="attempts"
                  placeholder=""
                  onChange={(e) => setAttempts(e.target.value)}
                  value={attempts}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <label htmlFor="class" className="form-label">
                  Class
                </label>
                <select
                  className="form-select"
                  id="class"
                  value={className}
                  onChange={(e) => setClassName(e.target.value)}
                  required
                >
                  <option value="" hidden>Select Class</option>
                  <option>Class XI</option>
                  <option>Class XII</option>
                  <option>Class XII Passed</option>
                </select>
              </div>
              <div className="col-lg-3">
                <label htmlFor="course" className="form-label">
                  Course
                </label>
                {
                  courses.length < 1 ?
                    <p>No course available</p>
                    :
                    <select
                      onChange={handleCourse}
                      className="form-select"
                      id="course"
                      aria-label="Select Course"
                      value={course ? course._id : ""}
                    >
                      <option hidden>Select Course</option>
                      {
                        courses.map((c, i) =>
                          <option key={i} value={c._id}>
                            {c.title}
                          </option>
                        )
                      }
                    </select>
                }
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-4">
                <label htmlFor="physicsTopics" className="form-label">
                  Physics Topics
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="physicsTopics"
                  placeholder="Topic 1, Topic 2"
                  value={physicsTopics}
                  onChange={(e) => setPhysicsTopics(e.target.value)}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="chemistryTopics" className="form-label">
                  Chemistry Topics
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="chemistryTopics"
                  placeholder="Topic 1, Topic 2"
                  value={chemistryTopics}
                  onChange={(e) => setChemistryTopics(e.target.value)}
                />
              </div>
              <div className="col-lg-4">
                <label htmlFor="biologyTopics" className="form-label">
                  Biology Topics
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="biologyTopics"
                  placeholder="Topic 1, Topic 2"
                  value={biologyTopics}
                  onChange={(e) => setBiologyTopics(e.target.value)}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-lg-6">
                <label className="form-label">Question Paper PDF</label>
                <input
                  type="file"
                  className="form-control"
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setQuestionPaperFile(file);
                    if (file) setPreviewQuestionPaper(URL.createObjectURL(file));
                  }}
                />
                {(previewQuestionPaper || questionPaperUrl) && (
                  <div className="mt-2" style={{ height: "400px" }}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={
                          previewQuestionPaper
                            ? previewQuestionPaper
                            : questionPaperUrl
                              ? `${baseUrl}${decodeURIComponent(questionPaperUrl)}`
                              : ''
                        }
                        plugins={[questionPaperLayoutPlugin]}
                      />
                    </Worker>
                  </div>
                )}
              </div>

              <div className="col-lg-6">
                <label className="form-label">Solution PDF</label>
                <input
                  type="file"
                  className="form-control"
                  accept="application/pdf"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    setSolutionFile(file);
                    if (file) setPreviewSolution(URL.createObjectURL(file));
                  }}
                />
                {(previewSolution || solutionUrl) && (
                  <div className="mt-2" style={{ height: "400px" }}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                      <Viewer
                        fileUrl={
                          previewSolution
                            ? previewSolution
                            : solutionUrl
                              ? `${baseUrl}${decodeURIComponent(solutionUrl)}`
                              : ''
                        }
                        plugins={[solutionLayoutPlugin]}
                      />
                    </Worker>
                  </div>
                )}
              </div>
            </div>

            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button disabled={loading} onClick={handleSubmit} className="btn btn-primary mt-4">
              {loading?'Updating...':'Update'}
            </button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EditExam;
